<template>
  <BaseButton primary class="float-right mt-4">
    {{ $t('next') }}
  </BaseButton>
</template>
